import { isWarnable } from '@tableau/data-catalog-shared';

import { openDataQualityDialogCatalog } from '../sagas/labels/SetDataQualitySaga';
import { openSenstiveLabelDialogCatalog } from '../sagas/labels/SetSensitiveLabelSaga';


export type RenderDataQualityDialogParams = {
  readonly content: {
    readonly contentId: string;
    readonly contentName: string;
    readonly contentType: string;
  };
  readonly dismiss: () => void;
}

export function renderDataQualityDialog(params: RenderDataQualityDialogParams): Promise<unknown> {
  const { contentId, contentName, contentType } = params.content;
  if (!isWarnable(contentType)) {
    return null;
  }

  return openDataQualityDialogCatalog({
    contentItem: {
      contentName,
      contentId,
      contentType,
    },
    onSubmit: params.dismiss,
  });
}

export function renderSensitiveLabelsDialog(params: RenderDataQualityDialogParams): Promise<unknown> {
  const { contentId, contentName, contentType } = params.content;
  if (!isWarnable(contentType)) {
    return null;
  }

  return openSenstiveLabelDialogCatalog({
    contentItem: {
      contentName,
      contentId,
      contentType,
    },
    onSubmit: params.dismiss,
  });
}
